import request from '@/natives/libs/request';

export default {
  getCountryFlag: () => request.get('/hpp/company/support/v1/ip/country')
};
